import { render } from "./CustomersAdminView.vue?vue&type=template&id=6fc9ff10"
import script from "./CustomersAdminView.vue?vue&type=script&lang=js"
export * from "./CustomersAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__